exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar[data-v-69bdd48d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 10px;\n}\n.tip-text[data-v-69bdd48d] {\n  font-size: 12px;\n  color: #606266;\n}\n.active-tip[data-v-69bdd48d] {\n  font-size: 12px;\n  color: #909399;\n  margin-bottom: 8px;\n}\n.dialog-footer[data-v-69bdd48d] {\n  text-align: center;\n  padding: 15px 0 5px;\n}\n", ""]);

// exports
